// eslint-disable-next-line import/named
import { Address } from '../interop/webmodule-interop.js';

/**
 * Pure address data helpers, deliberately free of any UI import.
 *
 * `emptyAddress` used to live in ui/maps/map-helpers, which imports Lit for its map templates. That
 * put a Lit dependency on the data layer for the sake of one object literal. map-helpers re-exports
 * this so its existing callers are unaffected.
 */

/**
 * Empty address object for the creation of clients, Projects, etc.
 */
export function emptyAddress(): Address {
  return {
    longitude: null,
    latitude: null,
    country: '',
    line1: '',
    line2: null,
    line3: null,
    line4: null,
    region: '',
    locality: '',
    postcode: '',
    source: null
  };
}
